import { httpService } from 'core-utilities';
import { Result } from '../../result';
import { toResult } from '../common';
import * as PromptAssignments from '../types/promptAssignments';

export const getAllForCurrentUser = (): Promise<
  Result<
    PromptAssignments.GetAllForCurrentUserReturnType,
    PromptAssignments.PromptAssignmentsError | null
  >
> =>
  toResult(
    httpService.get(PromptAssignments.GET_ALL_FOR_CURRENT_USER_CONFIG),
    PromptAssignments.PromptAssignmentsError
  );

export const updateForCurrentUser = (
  action: PromptAssignments.UpdateAction,
  promptType: PromptAssignments.PromptType
): Promise<
  Result<
    PromptAssignments.UpdateForCurrentUserReturnType,
    PromptAssignments.PromptAssignmentsError | null
  >
> =>
  toResult(
    httpService.post(PromptAssignments.UPDATE_FOR_CURRENT_USER_CONFIG, { action, promptType }),
    PromptAssignments.PromptAssignmentsError
  );
